import { Group, Switch, Paper } from '@mantine/core';
import { DatePickerInput, DatesRangeValue } from '@mantine/dates';

interface ChartControlsProps {
  dateRange: [Date, Date];
  onDateRangeChange: (dates: [Date, Date]) => void;
  showMovingAverage: boolean;
  onMovingAverageChange: (show: boolean) => void;
}

export function ChartControls({
  dateRange,
  onDateRangeChange,
  showMovingAverage,
  onMovingAverageChange,
}: ChartControlsProps) {
  return (
    <Paper p="md" withBorder radius={12} bg="var(--rdh-card-bg)">
      <Group justify="space-between">
        <DatePickerInput
          type="range"
          label="Date Range"
          placeholder="Pick dates range"
          defaultValue={dateRange}
          onChange={(dates: DatesRangeValue) => {
            // Handle partial selection (user clicked first date but not second)
            if (!dates) return;

            if (Array.isArray(dates)) {
              const [start, end] = dates;

              // Only update parent state if both dates are selected
              if (start && end) {
                const startDate = start instanceof Date ? start : new Date(start);
                const endDate = end instanceof Date ? end : new Date(end);
                onDateRangeChange([startDate, endDate]);
              }
            }
          }}
          maxDate={new Date()}
          clearable={false}
          valueFormat="MMM DD, YYYY"
          allowSingleDateInRange
        />

        <Switch
          label="Show Moving Average"
          checked={showMovingAverage}
          onChange={(event) => onMovingAverageChange(event.currentTarget.checked)}
        />
      </Group>
    </Paper>
  );
}
